import React, { useMemo } from 'react'
import { SketchPicker } from 'react-color'
import { Popup } from '../legacy/popup'
import { Label } from './common/label'
import { checkDirtyObjects, useForm } from './form'
import { IconColorPallet } from '../icon/icon'

export const FormSimpleColorRgba = ({ name, label, required, hidden, readonly }) => {
  const { register, getValue, setValue } = useForm(name, {
    required,
    valueAsObject: true,
    checkDirty: checkDirtyObjects,
    shouldDirty: true,
    defaultValue: '{"r":0,"g":0,"b":0,"a":1}'
  })

  const value = getValue()

  const handleColorChange = color => {
    let value = JSON.stringify(color.rgb)
    setValue(value)
  }

  const handleChange = e => setValue(e.target.value)

  const color = useMemo(
    () => {
      try {
        return JSON.parse(value)
      } catch {
        return {}
      }
    },
    [value]
  )

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <input type="hidden" {...register()} />

      <div className="input-group">
        <div className="input-group-text">
          <Popup selector={<IconColorPallet className="p-0" />}>
            <SketchPicker color={color} onChangeComplete={handleColorChange} />
          </Popup>
        </div>
        <input className="form-control" value={value} readOnly={readonly} onChange={handleChange} />
      </div>
    </Label>
  )
}
